export const projects = [
  {
    title: "Parche Solidario",
    description:
      "Plataforma web que conecta ciudadanos, organizaciones y fundaciones para impulsar causas sociales en Medellín: eventos comunitarios, colectas y refugios centralizados en un mapa interactivo.",
    tech: ["Next.js 15", "React 19", "TypeScript", "Tailwind CSS", "Firebase", "Leaflet"],
    highlight: "Clean Architecture con 4 capas (dominio, aplicación, infraestructura, presentación).",
    github: "https://github.com/SebastianDiazJ/ParcheSolidarioV2",
    featured: true,
  },
  {
    title: "Franchise API",
    description:
      "API REST reactiva para gestión de franquicias, sucursales y productos, con modelo de documentos embebidos y empaquetado completo en contenedores.",
    tech: ["Java 17", "Spring Boot 3", "WebFlux", "MongoDB", "Docker"],
    highlight: "Programación 100% reactiva (non-blocking) con Project Reactor.",
    github: "https://github.com/SebastianDiazJ/Manejo-de-franquicias",
    featured: true,
  },
  {
    title: "Ecommerce SOVAL",
    description:
      "Tienda en línea completamente funcional desarrollada durante mi etapa en SOVAL, con foco en experiencia de usuario, catálogo y rendimiento.",
    tech: ["React", "JavaScript", "E-commerce"],
    highlight: "Proyecto real de cliente, en producción.",
    github: "https://github.com/SebastianDiazJ/Ecomerce-soval",
  },
  {
    title: "To-Do List Ionic",
    description:
      "Aplicación móvil multiplataforma de gestión de tareas con categorías, filtros y banners controlados en tiempo real mediante feature flags.",
    tech: ["Ionic 7", "Angular 17", "Firebase Remote Config"],
    highlight: "Feature flags en producción sin re-despliegue.",
    github: "https://github.com/SebastianDiazJ/Aplicacion-To-Do-List-Mobile",
  },
];
